<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.0681 9.99984L6.95142 15.2057C6.60475 15.509 6.56975 16.0357 6.87308 16.3815C7.17642 16.7282 7.70308 16.7632 8.04892 16.4607L13.8823 10.6265C14.2614 10.2948 14.2614 9.70484 13.8823 9.37317L8.04892 3.53984C7.70308 3.23651 7.17642 3.27151 6.87308 3.61734C6.56975 3.96401 6.60475 4.49067 6.95142 4.79317L12.0681 9.99984Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>
